{
  "clear": "Borrar",
  "invalid": "(no válido)",
  "loading": "Cargando…",
  "noResults": "Sin resultados",
  "valid": "(válido)"
}
